import React, { useEffect, useState } from "react";
import Navbar from "../navbar";
import { Box, Button, HStack, IconButton, VStack } from "@chakra-ui/react";
import { DeleteIcon, LockIcon } from "@chakra-ui/icons";
import { collection, getDocs, deleteDoc, doc, Timestamp, getDoc, updateDoc } from "firebase/firestore";
import { db, auth } from '../../firebase';
import { useNavigate } from "react-router-dom";
import { useRunCode } from "../reducer/runCodeReducer";
import { useParams } from 'react-router-dom';
//import { Timestamp } from "firebase/firestore";


import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
} from '@chakra-ui/react';
import { confirmAlert } from "react-confirm-alert";

interface CodeData {
  auth: string,
  code: string,
  id: string,
  send_at: Timestamp,
  edit_at: string,
  lock: boolean
}

function TimeToString(send_at: any): string {
  // Convert send_at to a Timestamp if it is not already
  if (!(send_at instanceof Timestamp)) {
    send_at = Timestamp.fromMillis(send_at.seconds * 1000);
  }

  const date = new Date(send_at.toMillis());
  const day = date.getDate();
  const month = date.getMonth() + 1; // Months are 0-indexed
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;

  const formattedDateTime = `${hours}:${minutes} ${formattedDay}/${formattedMonth}/${year}`;
  return formattedDateTime;
}

function TatCaCode() {
  const { __id } = useParams();
  const Navigate = useNavigate();
  const [code, setCode] = useState<{ [key: string]: CodeData }>({});
  const { state, dispatch } = useRunCode();
  const [reload, setReload] = useState(false);

  const updateLock = async (code: CodeData) => {
    const userRef = doc(db, 'pubCode', code.id);
    try {
      if (code.lock == false) {
        await updateDoc(userRef, {
          lock: true,
        });
      } else {
        console.log(2)
        await updateDoc(userRef, {
          lock: false,
        });
      }
    } catch (error) {
      console.log("Error code: " + error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "pubCode"));
        const codeData: { [key: string]: CodeData } = {};
        querySnapshot.docs.forEach(doc1 => {
          const data = doc1.data() as CodeData;
          codeData[doc1.id] = { ...data, id: doc1.id };
          console.log(codeData[doc1.id])
        });
        // if (codeData[key].auth == state.user.email) {
        //const userAuthEmail = state.user.email;

        const filteredCodeData: { [key: string]: CodeData } = {};
        Object.keys(codeData).forEach(key => {
          //if (codeData[key].auth === userAuthEmail) {
            filteredCodeData[key] = codeData[key];
          //}
        });

        setCode(prevCode => ({ ...prevCode, ...filteredCodeData }));
        // }
        // Merge the fetched data with the existing state

      } catch (error) {
        console.error("Error fetching data from Firestore:", error);
      }
    };
    fetchData();
  }, [reload]);

  const editCode = (id: string) => {
    // const history = useHistory();
    Navigate("/" + id);
  }

  const deleteCode = async (id: string) => {
    await deleteDoc(doc(db, "pubCode", id));
  }

  if (state.user == null) return <>
    <Navbar />
    {/* {dispatch({ type: "noti", title: "Lỗi", content: "Vui lòng login hoặc đăng kí", icon: "error" })} */}
    <Box
      // bg="#dddbdb"
      w="68%"
      p={7}
      color="black"
      borderRadius="12px"
      margin="0px auto"
      marginTop="center"
    >
      <Alert
        status='error'
        variant='subtle'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        textAlign='center'
        height='200px'
      >
        <AlertIcon boxSize='40px' mr={0} />
        <AlertTitle mt={4} mb={1} fontSize='lg'>
          Lỗi !
        </AlertTitle>
        <AlertDescription maxWidth='sm'>
          Vui lòng đăng nhập hoặc đăng kí
        </AlertDescription>
      </Alert>
    </Box>
  </>

  return (
    <>
      <Navbar />
      {Object.keys(code).map((key) => (
        <div key={key}>
          <Box bg="#dddbdb" w="68%" p={3} color="black" borderRadius="12px" margin="0px auto" marginTop="15px" position={"relative"}>
            <p onClick={() => editCode(code[key].id)}>
              {code[key].code.split(' ').slice(0, 30).join(' ') + ' ... '}
            </p>
            <HStack width={"100%"}>
              <Box width={"50%"} textAlign={"start"}>
                <div>

                <b>Email: </b>{code[key].auth}
                </div>
                <b>Tạo lúc: </b>{TimeToString(code[key].send_at)} <b> | </b> {code[key].lock ? "Đã khóa" : "Chưa khóa"}
              </Box>
              <Box width={"50%"} textAlign={"end"}>
                <IconButton
                  colorScheme='gray'
                  aria-label='Search database'
                  icon={<LockIcon />}
                  onClick={() => {
                    confirmAlert({
                      title: 'Bạn có chắc chắc muốn khóa?',
                      message: 'Dữ liệu của ạn sẽ không thể nào có thể người khác xem được ngoài trừ bạn',
                      buttons: [
                        {
                          label: 'Xác nhận',
                          onClick: async () => {
                            updateLock(code[key])
                            setCode({})
                            setReload(!reload)
                          }
                        },
                        {
                          label: 'Hủy',
                        }
                      ]
                    });
                  }}
                />
                <IconButton
                  colorScheme='red'
                  aria-label='Search database'
                  icon={<DeleteIcon />}
                  onClick={() => {
                    confirmAlert({
                      title: 'Bạn có chắc chắc muốn xóa?',
                      message: 'Dữ liệu sẽ không thể nào được phục hồi nếu xóa',
                      buttons: [
                        {
                          label: 'Xác nhận',
                          onClick: () => {
                            deleteCode(code[key].id)
                            setCode({})
                            setReload(!reload)
                          }
                        },
                        {
                          label: 'Hủy',
                        }
                      ]
                    });
                  }}
                />
              </Box>
            </HStack>
          </Box>
        </div>
      ))}
    </>
  );
}

export default TatCaCode;
